(function() {
  var cfg = window.almpCfg || {};

  /* Galería carrusel */
  var track = document.getElementById('almp-gallery-track');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.almp-thumbs img'));
  var dots   = Array.prototype.slice.call(document.querySelectorAll('.almp-gallery-dot'));
  function setActive(idx) {
    thumbs.forEach(function(t,i){ t.classList.toggle('almp-active', i===idx); });
    dots.forEach(function(d,i){ d.classList.toggle('almp-on', i===idx); });
  }
  window.almgImg = function(thumb) {
    var idx = parseInt(thumb.dataset.idx,10)||0;
    if (track) track.scrollTo({left: idx*track.clientWidth, behavior:'smooth'});
    setActive(idx);
  };
  if (track) {
    var scrollTimer;
    track.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function(){
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        setActive(idx);
      }, 80);
    }, {passive:true});
  }

  /* Selector de variantes (color / talla) — solo aparece en productos con
     opciones reales. Sincroniza el input oculto del formulario (para que
     Releasit reciba la variante correcta), el precio mostrado y, si la
     variante tiene foto propia, la imagen principal de la galería. */
  var vRoot = document.getElementById('almp-variants');
  if (vRoot) {
    var variantsDataEl = document.getElementById('almp-variants-data');
    var variants = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];
    var vGroups = Array.prototype.slice.call(vRoot.querySelectorAll('.almp-vgroup'));
    var vSelected = vGroups.map(function (g) {
      var on = g.querySelector('.almp-vpill.almp-v-on');
      return on ? on.dataset.value : null;
    });

    function almpFindVariant(opts) {
      return variants.filter(function (v) {
        return opts.every(function (val, i) { return v['option' + (i + 1)] === val; });
      })[0];
    }
    function almpMoney(n) {
      // product.variants | json entrega el precio en centavos (x100).
      return '$' + Math.round(n / 100).toLocaleString('es-CO');
    }
    function almpUpdateAvailability() {
      vGroups.forEach(function (g, gi) {
        Array.prototype.slice.call(g.querySelectorAll('.almp-vpill')).forEach(function (p) {
          var testOpts = vSelected.slice();
          testOpts[gi] = p.dataset.value;
          var m = almpFindVariant(testOpts);
          p.classList.toggle('almp-v-off', !m || m.available === false);
        });
      });
    }
    function almpApplyVariant(v) {
      if (!v) return;
      var form = document.getElementById('almp-product-form');
      if (form) {
        var input = form.querySelector('input[name="id"]');
        if (input) { input.value = v.id; input.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      var priceEl = document.querySelector('.almp-price-current');
      var origEl = document.querySelector('.almp-price-original');
      if (priceEl && v.price != null) priceEl.textContent = almpMoney(v.price);
      if (origEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          origEl.style.display = '';
          origEl.textContent = 'Antes: ' + almpMoney(v.compare_at_price);
        } else {
          origEl.style.display = 'none';
        }
      }
      if (v.featured_image && v.featured_image.src && thumbs.length) {
        var fname = v.featured_image.src.split('?')[0].split('/').pop();
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].src.indexOf(fname.split('.')[0]) > -1) { window.almgImg(thumbs[i]); break; }
        }
      }
    }

    vRoot.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.almp-vpill');
      if (!btn || btn.classList.contains('almp-v-off')) return;
      var gi = parseInt(btn.dataset.optionIndex, 10);
      vSelected[gi] = btn.dataset.value;
      Array.prototype.slice.call(vGroups[gi].querySelectorAll('.almp-vpill')).forEach(function (p) {
        p.classList.toggle('almp-v-on', p === btn);
      });
      var lbl = document.getElementById('almp-vlabel-' + gi);
      if (lbl) lbl.textContent = btn.dataset.value;
      almpUpdateAvailability();
      almpApplyVariant(almpFindVariant(vSelected));
    });

    almpUpdateAvailability();
  }

  /* Stock aleatorio estable por día */
  var stockN    = document.getElementById('almp-stock-n');
  var stockFill = document.getElementById('almp-stock-fill');
  if (stockN && cfg.pid) {
    var seed  = (cfg.pid % 9973) + new Date().getDate()*31 + new Date().getMonth()*7;
    var units = 4 + (seed % 9);
    stockN.textContent = units;
    if (stockFill) stockFill.style.width = Math.max(10, units*6) + '%';
  }

  /* Fecha de entrega dinámica */
  var elDel = document.getElementById('almp-delivery-date');
  if (elDel && cfg.dynDelivery) {
    var meses = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto',
                 'septiembre','octubre','noviembre','diciembre'];
    function addBD(date,days){ var d=new Date(date); while(days>0){d.setDate(d.getDate()+1);if(d.getDay()!==0&&d.getDay()!==6)days--;} return d; }
    var from=addBD(new Date(),2), to=addBD(new Date(),5);
    elDel.textContent='Se entrega entre el '+from.getDate()+' y el '+to.getDate()+' de '+meses[to.getMonth()];
  }

  /* FAQ acordeón */
  document.querySelectorAll('.almp-faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item   = btn.closest('.almp-faq-item');
      var isOpen = item.classList.contains('almp-open');
      document.querySelectorAll('.almp-faq-item.almp-open').forEach(function(el){
        el.classList.remove('almp-open');
        el.querySelector('.almp-faq-q').setAttribute('aria-expanded','false');
      });
      if (!isOpen){ item.classList.add('almp-open'); btn.setAttribute('aria-expanded','true'); }
    });
  });

  /* Scroll reveal */
  if ('IntersectionObserver' in window) {
    var revObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('almp-in'); revObs.unobserve(e.target); }
      });
    }, {threshold:0.08});
    document.querySelectorAll('.almp-reveal').forEach(function(el){ revObs.observe(el); });
  } else {
    document.querySelectorAll('.almp-reveal').forEach(function(el){ el.classList.add('almp-in'); });
  }

  /* Videos lazy — con reintento: en móvil (y sobre todo en el navegador
     embebido de apps como Facebook) es común que la primera carga se quede
     "stalled" sin motivo (a veces por estar la pestaña en segundo plano un
     instante). Sin reintento esos videos quedaban en blanco para siempre. */
  var MAX_RETRIES = 3;
  var RETRY_MS = 3500;
  function attemptLoad(v){
    var retries = parseInt(v.dataset.retries || '0', 10);
    v.dataset.retries = String(retries + 1);
    v.querySelectorAll('source').forEach(function(s){ s.remove(); });
    var s=document.createElement('source');
    s.src=v.dataset.vsrc; s.type='video/mp4';
    v.appendChild(s);
    v.load();
    v.play().catch(function(){});
    clearTimeout(v._almpRetryTimer);
    v._almpRetryTimer = setTimeout(function(){
      if (v.readyState === 0 && retries + 1 < MAX_RETRIES) attemptLoad(v);
    }, RETRY_MS);
  }
  function loadVideo(v){
    if (v.dataset.loaded) return;
    v.dataset.loaded='1';
    v.addEventListener('loadeddata', function(){ clearTimeout(v._almpRetryTimer); }, {once:true});
    v.addEventListener('stalled', function(){
      var retries = parseInt(v.dataset.retries || '0', 10);
      if (v.readyState === 0 && retries < MAX_RETRIES) attemptLoad(v);
    });
    attemptLoad(v);
  }
  var lazyVids = document.querySelectorAll('.almp-lazy-video');
  if (lazyVids.length) {
    if ('IntersectionObserver' in window) {
      var vidObs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){loadVideo(e.target);vidObs.unobserve(e.target);} });
      }, {rootMargin:'400px 0px'});
      lazyVids.forEach(function(v){ vidObs.observe(v); });
    } else { lazyVids.forEach(loadVideo); }

    /* Red de seguridad: si el usuario vuelve a la pestaña (o a la app) y
       algún video se quedó pegado en "cargando" desde antes, reintenta. */
    document.addEventListener('visibilitychange', function(){
      if (document.visibilityState !== 'visible') return;
      lazyVids.forEach(function(v){
        if (v.dataset.loaded && v.readyState === 0) {
          var retries = parseInt(v.dataset.retries || '0', 10);
          if (retries < MAX_RETRIES) attemptLoad(v);
        }
      });
    });
  }
})();
